import React, { forwardRef, RefAttributes, useImperativeHandle } from 'react'
import { IOuterTableRef, TableProps } from './table.model'

import 'ag-grid-community/styles/ag-grid.css' // Core CSS
import 'ag-grid-community/styles/ag-theme-quartz.css' // Theme
import './styles/index.scss'
import TableProvider, { providerRef } from './components/TableProvider'
import TableContent from './components/TableContent'

// Create new GridExample component
const NewCommonTable: React.FC<RefAttributes<Partial<IOuterTableRef>> & TableProps> = forwardRef<
  Partial<IOuterTableRef>,
  TableProps
>((props, ref) => {
  useImperativeHandle(ref, () => ({ ...providerRef.current }))
  return (
    <TableProvider ref={providerRef} {...props}>
      <TableContent />
    </TableProvider>
  )
})
export default NewCommonTable
